const getUserId = (rootState) =>
  rootState.ws.integration.settings.userData && rootState.ws.integration.settings.userData.id;

export default getUserId;
